import { CitationContext, Snippet } from '../models/result-set';

export const formatNumber = (num: number) =>
  new Intl.NumberFormat().format(num);

export function formatCitation(
  snippets: Array<Snippet | CitationContext> | undefined,
): string | undefined {
  if (snippets === undefined || snippets.length === 0) {
    return undefined;
  }
  return `“${snippets
    .map((s) => stripCommonPrefixes(s.text))
    .join(' [...] ')}”`;
}

export function formatAuthorName(
  name: string,
  opts?: { shorten?: boolean },
): string {
  const formattedName = capitalizeWord(name);

  if (opts?.shorten) {
    return formattedName
      .split(' ')
      .filter((a) => a.length > 0)
      .map((w, i, words) =>
        i === words.length - 1
          ? capitalizeWord(w)
          : capitalizeWord(getFirstInitial(w)),
      )
      .join(' ');
  }

  return formattedName;
}

export function formatPaperSectionTitle(title: string): string {
  const strippedTitle = stripCommonPrefixes(title);
  const lowerStrippedTitle = strippedTitle.toLocaleLowerCase();
  const upperStrippedTitle = strippedTitle.toLocaleUpperCase();

  const needsCapitalization =
    lowerStrippedTitle === strippedTitle ||
    upperStrippedTitle === strippedTitle;

  if (needsCapitalization) {
    return capitalizeAllWords(strippedTitle);
  } else {
    return strippedTitle;
  }
}

function getFirstInitial(s: string): string {
  return !s.length ? '' : s[0] + '.';
}

function capitalizeAllWords(text: string): string {
  return text.toLocaleLowerCase().split(' ').map(capitalizeWord).join(' ');
}

function capitalizeWord(s: string): string {
  return !s.length ? '' : s[0].toUpperCase() + s.slice(1);
}

function stripCommonPrefixes(text: string): string {
  return text
    .replace(/^[iIvVxXlLcCdDmM]+\.\s/, '') // strip roman numerals prefix
    .replace(/^\w\.\s/, '') // strip prefixes like A. B. ....
    .replace(/^\d+\.\s/, '') // strip prefixes like 1. 2. ....
    .replace(/^•\s*/, ''); // strip bullet prefix
}
